export default __webpack_public_path__ + "static/22-2a6602bfc981f98516acb661f9722082.jpg";